// @flow

import { combineReducers } from 'redux';
import { intlReducer } from 'react-intl-redux';

import type { Reducer } from 'redux';

import type { Action } from '../types/redux';
import type { State as CategoriesState } from './modules/categories';
import type { State as ProductsState } from './modules/products';
import type { State as ArticlesState } from './modules/articles';

import categories from './modules/categories';
import products from './modules/products';
import articles from './modules/articles';

export type State = {
  intl: Object,
  categories: CategoriesState,
  products: ProductsState,
  articles: ArticlesState,
};

const rootReducer: Reducer<State, Action> = combineReducers({
  intl: intlReducer,
  categories,
  products,
  articles,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux/rootReducer.js